import $ from 'jquery';
import _ from 'underscore';
import { get } from '@bingads-webui-universal/primitive-utilities';
import tmplTextInput from '../../template/simple-form/control/text-input.pug';
import tmplTextareaInput from '../../template/simple-form/control/textarea.pug';
import tmplSelectInput from '../../template/simple-form/control/select-input.pug';
import tmplCheckboxInput from '../../template/simple-form/control/checkbox-input.pug';
import tmplRadiosInput from '../../template/simple-form/control/radios-input.pug';
import tmplInlineRadiosInput from '../../template/simple-form/control/inline-radios-input.pug';
import tmplStatic from '../../template/simple-form/control/static.pug';
import { isBackboneView, bindTo } from '../util';

function getBuiltInControlTemplate(control) {
  return get({
    checkbox: tmplCheckboxInput,
    collapse: _.constant(''),
    group: _.constant(''),
    'inline-radios': tmplInlineRadiosInput,
    radios: tmplRadiosInput,
    select: tmplSelectInput,
    static: tmplStatic,
    text: tmplTextInput,
    textarea: tmplTextareaInput,
  }, control, null);
}

export function normalizeControl(field, type) {
  const { control } = field;
  const callTemplate = template => template({
    field,
    type,
    bindTo,
  });
  const callBuiltInTemplate =
    builtInControl => callTemplate(getBuiltInControlTemplate(builtInControl));

  if (isBackboneView(control)) {
    return control;
  }

  if (_.isFunction(control)) {
    const $el = $(`<div>${callTemplate(control)}</div>`);
    let builtInControl = null;

    const $builtInControl = $el.find('.form-input[data-control]');

    if ($builtInControl.length) {
      builtInControl = $builtInControl[0].dataset.control;
      $builtInControl.append(callBuiltInTemplate(builtInControl));
    }

    return {
      builtInControl,
      html: $el.html(),
    };
  }

  if (_.isObject(control)) {
    return control;
  }

  return {
    builtInControl: control,
    html: callBuiltInTemplate(control),
  };
}
